import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { UtilsService } from '../../../../../services/utils/utils.service';
import { RdSAPGeneralDetailUIDTOV0 } from 'src/rdsap-api';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-rdsap-summary-addenda',
  templateUrl: './addenda.component.html',
  styleUrls: ['./addenda.component.scss']
})

export class AddendaComponent implements OnInit {
  @Input() getAddendum: any;
  hardToTreatAccessIssues = false;
  hardToTreatHighExposure = false;
  hardToTreatNarrowCavities = false;

  selectedAddenda: any[] = [];
  addendaOptions = cloneDeep(this.filterLookupCodes('AddendaToEPC'));
  eeGeneralDetails: RdSAPGeneralDetailUIDTOV0 = {
    address: undefined
  };

  constructor(
    private utilsService: UtilsService,
  ) { }

  @Output() addendaData = new EventEmitter<any>();
  // here, use ngonchanges to make sure that checkboxes keep their state after refresh
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['getAddendum'] && this.getAddendum) {
      this.updateAddendumState();
    }
  }

  ngOnInit(): void {
    // here, call initializer on component load
    this.updateAddendumState();
  }

  // here, reusable initializer for addendum states
  updateAddendumState(): void {
    this.eeGeneralDetails.addendum = this.eeGeneralDetails?.addendum || {};

    if (this.getAddendum) {
      this.hardToTreatAccessIssues = this.getAddendum.accessIssues || false;
      this.hardToTreatHighExposure = this.getAddendum.highExposure || false;
      this.hardToTreatNarrowCavities = this.getAddendum.narrowCavities || false;
    }

    if (this.getAddendum?.addendumNumbers) {
      this.addendaOptions = this.addendaOptions.map(item => ({
        ...item,
        selected: this.getAddendum?.addendumNumbers.includes(item.lookupValue)
      }));
    }

    this.selectedAddenda = this.addendaOptions
      .filter(item => item.selected)
      .map(item => item.lookupValue);
  }


  filterLookupCodes(filter) {
    return this.utilsService.filterLookupCodes(filter);
  }

  updateAddendaSelection(index: number, isSelected: boolean): void {
    const lookupValue = this.addendaOptions[index].lookupValue;
    if (isSelected) {
      if (!this.selectedAddenda.includes(lookupValue)) {
        this.selectedAddenda.push(lookupValue);
      }
      this.addendaOptions[index].selected = true;
    } else {
      const selectedIndex = this.selectedAddenda.indexOf(lookupValue);
      if (selectedIndex > -1) {
        this.selectedAddenda.splice(selectedIndex, 1);
      }
      this.addendaOptions[index].selected = false;
    }
    this.eeGeneralDetails.addendum.addendumNumbers = this.selectedAddenda;
    this.addendaData.emit(this.eeGeneralDetails);
  }

  updateHardToTreatCavityWallsSection() {
    this.eeGeneralDetails.addendum.accessIssues = this.hardToTreatAccessIssues;
    this.eeGeneralDetails.addendum.narrowCavities = this.hardToTreatNarrowCavities;
    this.eeGeneralDetails.addendum.highExposure = this.hardToTreatHighExposure;
    this.addendaData.emit(this.eeGeneralDetails);
  }
}
